import { AttachmentAddedEvent, AttachmentDeletedEvent } from './attachmentEvents';
import { CardActivityCreatedEvent } from './cardActivityEvents';

// Relais générique BoardPage (useBoardChannel) → CardModal/AttachmentList ouverts,
// sans abonnement Reverb par carte. Sur le même principe que commentEventBus (Phase 4),
// mais pour les besoins Phase 6 qui n'ont pas de state déjà porté par le prop `card`
// (pièces jointes, activités) : labels/affectations/description/label_color, eux,
// sont déjà couverts par le payload CardUpdated existant et n'ont pas besoin de ce bus.
export type CardModalBusEvent =
  | { type: 'attachment-added'; event: AttachmentAddedEvent }
  | { type: 'attachment-deleted'; event: AttachmentDeletedEvent }
  | { type: 'activity-created'; event: CardActivityCreatedEvent };

type Listener = (event: CardModalBusEvent) => void;

const listeners = new Set<Listener>();

export const publishCardModalEvent = (event: CardModalBusEvent): void => {
  listeners.forEach((listener) => listener(event));
};

export const subscribeToCardModalEvents = (listener: Listener): (() => void) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};
